import { RouteObject } from "react-router-dom";

import { appRoutes } from "./app-routes";
import { getRouteChildren } from "./helpers";

export const routes: RouteObject[] = getRouteChildren({
  routes: appRoutes,
});
